import { defineMessages } from 'react-intl';

const messages = defineMessages({
  insureAmount: {
    description: 'Label for a field to input how much money to insure a shipment for',
    defaultMessage: 'Insure Amount',
    id: 'uL+q0U',
  },
  sizeLabel: {
    description: 'Label (with unit of measurement, inches or centimeters) for the size fields, used to input shipment dimensions',
    defaultMessage: 'Size ({isMetric, select, true {cm} other {in}})',
    id: 'oo+zXb',
  },
  trackingStatus: {
    description: 'Label for a shipments tracking status',
    defaultMessage: 'Status',
    id: '6uUetu',
  },
  returnTo: {
    description: 'Label for the "ship to" address of a return shipment',
    defaultMessage: 'Return To',
    id: 'vTiOix',
  },
  externalFulfillmentCarrier: {
    description: "Label for a field that tells users which 'carrier' delivered their shipment.",
    defaultMessage: 'Carrier',
    id: 'XBVbGw',
  },
  delegationDate: {
    description:
      'Label for a field that tells users when they sent the order to their fulfillment partner and charged their fulfillment partner with fulfilling the order.',
    defaultMessage: 'Delegation Date',
    id: 'D7/oiM',
  },
  fulfillmentProvider: {
    description:
      'Label for a field that tells users the name of the logistics provider they delegated the order to. This is a term we use for a company that provides order fulfillment services, hence "fulfillment provider"',
    defaultMessage: 'Fulfillment Provider',
    id: 'y5Ujft',
  },
  rate: {
    description: 'Label for a field that tells users the "shipping rate" they paid.',
    defaultMessage: 'Rate',
    id: 'WHw6Vq',
  },
  shipDate: {
    description: 'Label for a field that tells users the date their item was shipped.',
    defaultMessage: 'Ship Date',
    id: 'u98wIs',
  },
  trackingNumber: {
    description: 'Label for a field that tells users the tracking number for their shipment.',
    defaultMessage: 'Tracking Number',
    id: 'PuJT+c',
  },
  fileAClaimLink: {
    description: 'Link to an external site where a user can file an insurance claim. Link opens in a new browser window.',
    defaultMessage: 'File a Claim',
    id: 'D1+MQW',
  },
});

export default messages;
